import '../styles/pages/legal.css'

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Vilkår og Betingelser</h1>
        <p className="last-updated">Sidst opdateret: {new Date().toLocaleDateString('da-DK')}</p>

        <section>
          <h2>1. Tjenesten</h2>
          <p>
            Parkort er en tjeneste der hjælper par og relationer med at tale om vigtige emner gennem strukturerede spørgsmål og feedback. 
            Tjenesten giver dig mulighed for at oprette kort med emner, dele dem med andre, og modtage svar med match scores og feedback.
          </p>
        </section>

        <section>
          <h2>2. Brugsbetingelser</h2>
          <h3>2.1 Minimumsalder</h3>
          <p>Du skal være mindst 18 år gammel for at bruge Parkort.</p>

          <h3>2.2 Ansvar for Indhold</h3>
          <p>
            Du er ansvarlig for alt indhold du opretter og deler gennem Parkort. Du må ikke:
          </p>
          <ul>
            <li>Oprette indhold der er ulovligt, skadeligt, truende, chikanerende eller krænkende</li>
            <li>Misbruge tjenesten til spam eller uønsket kommunikation</li>
            <li>Forsøge at hacke eller skade tjenesten</li>
            <li>Kopiere eller reproducere tjenesten uden tilladelse</li>
          </ul>

          <h3>2.3 Selvhjælp, Ikke Behandling</h3>
          <p>
            Parkort er et selvhjælpsværktøj og er <strong>ikke</strong> en erstatning for professionel terapi, 
            rådgivning eller behandling. Hvis du har behov for professionel hjælp, skal du kontakte en kvalificeret professionel.
          </p>
        </section>

        <section>
          <h2>3. Betaling og Abonnement</h2>
          <h3>3.1 Gratis Version</h3>
          <p>
            Parkort tilbyder en gratis version med adgang til begrænsede moduler. Gratis versionen har ingen skjulte omkostninger.
          </p>

          <h3>3.2 Premium Abonnement</h3>
          <p>
            Premium abonnement giver adgang til alle moduler og avancerede features. 
            Abonnementet fornyes automatisk hver måned eller år (afhængigt af dit valg) indtil du opsiger det.
          </p>

          <h3>3.3 Opsigelse</h3>
          <p>
            Du kan opsige dit Premium abonnement når som helst. Opsigelse træder i kraft ved næste faktureringsperiode. 
            Du beholder adgang til Premium features indtil abonnementet udløber.
          </p>

          <h3>3.4 Refund Policy</h3>
          <p>
            Hvis du ikke er tilfreds med Premium, kan du anmode om refusion inden for 14 dage efter køb. 
            Kontakt os på <a href="mailto:info@thomasvalenzuela.com">info@thomasvalenzuela.com</a>.
          </p>
        </section>

        <section>
          <h2>4. Opsigelse af Tjenesten</h2>
          <h3>4.1 Af Dig</h3>
          <p>
            Du kan stoppe med at bruge Parkort når som helst. Du kan slette dine kort ved at slette delte links.
          </p>

          <h3>4.2 Af Os</h3>
          <p>
            Vi kan suspendere eller opsige din adgang til tjenesten hvis du:
          </p>
          <ul>
            <li>Bryder disse vilkår</li>
            <li>Misbruger tjenesten</li>
            <li>Udbetaler ikke for Premium abonnement</li>
          </ul>
        </section>

        <section>
          <h2>5. Ansvar og Ansvarsfraskrivelse</h2>
          <h3>5.1 Ingen Garanti</h3>
          <p>
            Tjenesten leveres "som den er" uden nogen form for garanti. Vi garanterer ikke:
          </p>
          <ul>
            <li>At tjenesten altid vil være tilgængelig eller fejlfri</li>
            <li>At resultaterne vil være nøjagtige eller pålidelige</li>
            <li>At tjenesten vil løse dine relationelle udfordringer</li>
          </ul>

          <h3>5.2 Begrænset Ansvar</h3>
          <p>
            Vores ansvar er begrænset til det beløb du har betalt for Premium abonnement i de seneste 12 måneder. 
            Vi er ikke ansvarlige for indirekte, tilfældige eller følgeskader.
          </p>
        </section>

        <section>
          <h2>6. Intellektuel Ejendomsret</h2>
          <h3>6.1 Vores Indhold</h3>
          <p>
            Alt indhold på Parkort (design, tekst, logoer, kode) er vores ejendom eller vores licensgivere. 
            Du må ikke kopiere, reproducere eller distribuere indholdet uden tilladelse.
          </p>

          <h3>6.2 Dit Indhold</h3>
          <p>
            Du beholder alle rettigheder til det indhold du opretter gennem Parkort. 
            Ved at bruge tjenesten giver du os tilladelse til at vise og behandle dit indhold for at levere tjenesten.
          </p>
        </section>

        <section>
          <h2>7. Links til Tredjeparter</h2>
          <p>
            Parkort kan indeholde links til tredjeparters websites. Vi er ikke ansvarlige for indholdet eller 
            privatlivspraksis på disse websites.
          </p>
        </section>

        <section>
          <h2>8. Gældende Lov</h2>
          <p>
            Disse vilkår er underlagt dansk lov. Eventuelle tvister skal løses ved danske domstole.
          </p>
        </section>

        <section>
          <h2>9. Ændringer af Vilkår</h2>
          <p>
            Vi kan opdatere disse vilkår fra tid til anden. Væsentlige ændringer vil blive kommunikeret via email eller 
            via en notifikation på hjemmesiden. Fortsat brug af tjenesten efter ændringer betyder accept af de nye vilkår.
          </p>
        </section>

        <section>
          <h2>10. Kontakt</h2>
          <p>
            Hvis du har spørgsmål til disse vilkår, kontakt os på:<br />
            <strong>Email:</strong> <a href="mailto:info@thomasvalenzuela.com">info@thomasvalenzuela.com</a>
          </p>
        </section>
      </div>
    </div>
  )
}

export default TermsOfService
